<div class="form-group">
  <select class="select-form-control" [(ngModel)]="selectedBillType"
          value="" (focus)="selectFirst()"
          [class.form-error] = "hasError" id="billTypeId"
          (change)= "sendBillName()">
    <option *ngFor="let bill of billTypeList;let i= index" [ngValue]="bill">{{bill.name}}</option>
  </select>
  <span class="floating-label">نوع قبض</span>
  <span class="star">*</span>
  <span *ngIf="hasError" class="errorInput">پر کردن این فیلد الزامی است.</span>
</div>
